module.exports = __webpack_public_path__ + "img/bcard_8.b7225f8d.png";